import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles((theme: Theme) => ({
  maintenanceDiv: {
    fontFamily: "Manrope !important",
    padding: "16px 32px",
  },
  shipmentTabs: {
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
    borderRadius: "0px 0px 12px 12px",
  },
  shipmentsHeader: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#F8FAFC",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    padding: "20px 32px 20px 40px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      "&:nth-last-child(n)": {
        marginTop: "8px",
      },
    },
  },
  shipmentStatus: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  shipmentStatusTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
  },
}));

export default styles;
